import { render, staticRenderFns } from "./LocationDetails.vue?vue&type=template&id=b46ebce6&"
import script from "./LocationDetails.vue?vue&type=script&lang=js&"
export * from "./LocationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports